// Import external dependencies first
import { openDB } from 'idb';
import Constant from './constants';

// Connector SVG imports - use public folder paths as strings for runtime loading
const PlugCCSType2 = "/assets/connectorSvg/img_connector_1.svg";
const PlugType2 = "/assets/connectorSvg/img_connector_2.svg";
const PlugChademo = "/assets/connectorSvg/img_connector_3.svg";
const PlugType1 = "/assets/connectorSvg/img_connector_4.svg";
const PlugType1AC = "/assets/connectorSvg/img_connector_4.svg";
const PlugType3Pin = "/assets/connectorSvg/img_connector_6.svg";
const PlugGbt = "/assets/connectorSvg/img_connector_7.svg";
const PlugTypeThreePhase = "/assets/connectorSvg/img_sockets_3_phase.svg";
const PlugTypeCCSType1 = "/assets/connectorSvg/img_sockets_CCS_type_1.svg";
const PlugTypeCSSSAE = "/assets/connectorSvg/img_sockets_CCS_type_1.svg";
const PlugTypeIEC60309 = "/assets/connectorSvg/img_sockets_iec60309.svg";
const PlugTypeJ1772 = "/assets/connectorSvg/img_sockets_j1772.svg";
const PlugTypeWall = "/assets/connectorSvg/img_sockets_Wall.svg";
const PlugCCSType2PNG = "/assets/plug_combo_2.png";
const SpeedFastPNG = "/assets/speed_fast.png";
const SpeedRapidPNG = "/assets/speed_rapid.png";
const SlowPNG = "/assets/speed_slow.png";
const SpeedUltraRapidPNG = "/assets/speed_ultra_rapid.png";

const DefaultMarkerPNG = "/assets/balloon-gray-dot.svg";
const EV15PNG = '/assets/EV-15.png';
const EV16PNG = '/assets/EV-16.png';
const EV18PNG = '/assets/EV-18.png';
const EV19PNG = '/assets/EV-19.png';
const fourWheelerGeneric = '/assets/genericVehicleSegment/fourWheelerGeneric.png';
const threeWheelerGeneric = '/assets/genericVehicleSegment/threeWheelerGeneric.png';
const twoWheelerGeneric = '/assets/genericVehicleSegment/twoWheelerGeneric.png';
const Icon14 = '/assets/icon-14.png';
const Icon15 = '/assets/icon-15.png';
const Icon16 = '/assets/icon-16.png';
const Icon17 = '/assets/icon-17.png';
const FaultConnectorImage = '/assets/Others_Switch.svg';

// Network filter images - use public folder paths as strings
const AARGO = "/assets/networkFilter/AARgo.svg";
const AARGO_GREEN = "/assets/networkFilter/AARgo_green.svg";
const AARGO_GREY = "/assets/networkFilter/AARgo_grey.svg";
const AARGO_RED = "/assets/networkFilter/AARgo_red.svg";
const ATHER = "/assets/networkFilter/Ather.svg";
const ATHER_GREEN = "/assets/networkFilter/Ather_green.svg";
const ATHER_GREY = "/assets/networkFilter/Ather_grey.svg";
const ATHER_RED = "/assets/networkFilter/Ather_red.svg";
const CHARGE_GRID = "/assets/networkFilter/ChargeGrid.svg";
const CHARGE_GRID_GREEN = "/assets/networkFilter/ChargeGrid_green.svg";
const CHARGE_GRID_GREY = "/assets/networkFilter/ChargeGrid_grey.svg";
const CHARGE_GRID_RED = "/assets/networkFilter/ChargeGrid_red.svg";
const CHARGE_ZONE = "/assets/networkFilter/ChargeZone.svg";
const CHARGE_ZONE_GREEN = "/assets/networkFilter/ChargeZone_green.svg";
const CHARGE_ZONE_GREY = "/assets/networkFilter/ChargeZone_grey.svg";
const CHARGE_ZONE_RED = "/assets/networkFilter/ChargeZone_red.svg";
const EFILL = "/assets/networkFilter/Efill.svg";
const EFILL_GREEN = "/assets/networkFilter/Efill_green.svg";
const EFILL_GREY = "/assets/networkFilter/Efill_grey.svg";
const EFILL_RED = "/assets/networkFilter/Efill_red.svg";
const ELECTRIVA = "/assets/networkFilter/Electriva.svg";
const ELECTRIVA_GREEN = "/assets/networkFilter/Electriva_green.svg";
const ELECTRIVA_GREY = "/assets/networkFilter/Electriva_grey.svg";
const ELECTRIVA_RED = "/assets/networkFilter/Electriva_red.svg";
const EVRE = "/assets/networkFilter/EVRe.svg";
const EVRE_GREEN = "/assets/networkFilter/EVRe_green.svg";
const EVRE_GREY = "/assets/networkFilter/EVRe_grey.svg";
const EVRE_RED = "/assets/networkFilter/EVRe_red.svg";
const FORTUM = "/assets/networkFilter/Fortum.svg";
const FORTUM_GREEN = "/assets/networkFilter/Fortum_green.svg";
const FORTUM_GREY = "/assets/networkFilter/Fortum_grey.svg";
const FORTUM_RED = "/assets/networkFilter/Fortum_red.svg";
const GOEGO = "/assets/networkFilter/Goego.svg";
const GOEGO_GREEN = "/assets/networkFilter/Goego_green.svg";
const GOEGO_GREY = "/assets/networkFilter/Goego_grey.svg";
const GOEGO_RED = "/assets/networkFilter/Goego_red.svg";
const JIO_BP = "/assets/networkFilter/JioBP.svg";
const JIO_BP_GREEN = "/assets/networkFilter/JioBP_green.svg";
const JIO_BP_GREY = "/assets/networkFilter/JioBP_grey.svg";
const JIO_BP_RED = "/assets/networkFilter/JioBP_red.svg";
const RELUX = "/assets/networkFilter/Relux.svg";
const RELUX_GREEN = "/assets/networkFilter/Relux_green.svg";
const RELUX_GREY = "/assets/networkFilter/Relux_grey.svg";
const RELUX_RED = "/assets/networkFilter/Relux_red.svg";
const STATIQ = "/assets/networkFilter/Statiq.svg";
const STATIQ_GREEN = "/assets/networkFilter/Statiq_green.svg";
const STATIQ_GREY = "/assets/networkFilter/Statiq_grey.svg";
const STATIQ_RED = "/assets/networkFilter/Statiq_red.svg";
const TATA = "/assets/networkFilter/Tata.svg";
const TATA_GREEN = "/assets/networkFilter/Tata_green.svg";
const TATA_GREY = "/assets/networkFilter/Tata_grey.svg";
const TATA_RED = "/assets/networkFilter/Tata_red.svg";
const VOLTTIC = "/assets/networkFilter/Volttic.svg";
const VOLTTIC_GREEN = "/assets/networkFilter/Volttic_green.svg";
const VOLTTIC_GREY = "/assets/networkFilter/Volttic_grey.svg";
const VOLTTIC_RED = "/assets/networkFilter/Volttic_red.svg";
const XOBOLT = "/assets/networkFilter/XObolt.svg";
const XOBOLT_GREEN = "/assets/networkFilter/XObolt_green.svg";
const XOBOLT_GREY = "/assets/networkFilter/XObolt_grey.svg";
const XOBOLT_RED = "/assets/networkFilter/XObolt_red.svg";
const ZEON = "/assets/networkFilter/Zeon.svg";
const ZEON_GREEN = "/assets/networkFilter/Zeon_green.svg";
const ZEON_GREY = "/assets/networkFilter/Zeon_grey.svg";
const ZEON_RED = "/assets/networkFilter/Zeon_red.svg";

const BBMP = "/assets/networkFilter/BBMP.svg";
const BBMP_GREEN = "/assets/networkFilter/BBMP_green.svg";
const BBMP_GREY = "/assets/networkFilter/BBMP_grey.svg";
const BBMP_RED = "/assets/networkFilter/BBMP_red.svg";
const BECIL = "/assets/networkFilter/BECIL.svg";
const BECIL_GREEN = "/assets/networkFilter/BECIL_green.svg";
const BECIL_GREY = "/assets/networkFilter/BECIL_grey.svg";
const BECIL_RED = "/assets/networkFilter/BECIL_red.svg";
const DELTA = "/assets/networkFilter/Delta.svg";
const DELTA_GREEN = "/assets/networkFilter/Delta_green.svg";
const DELTA_GREY = "/assets/networkFilter/Delta_grey.svg";
const DELTA_RED = "/assets/networkFilter/Delta_red.svg";
const EESL = "/assets/networkFilter/EESL.svg";
const EESL_GREEN = "/assets/networkFilter/EESL_green.svg";
const EESL_GREY = "/assets/networkFilter/EESL_grey.svg";
const EESL_RED = "/assets/networkFilter/EESL_red.svg";
const GENERIC = "/assets/networkFilter/Generic.svg";
const GENERIC_GREEN = "/assets/networkFilter/Generic_green.svg";
const GENERIC_GREY = "/assets/networkFilter/Generic_grey.svg";
const GENERIC_RED = "/assets/networkFilter/Generic_red.svg";
const INSTAVOLT = "/assets/networkFilter/InstaVolt.svg";
const INSTAVOLT_GREEN = "/assets/networkFilter/InstaVolt_green.svg";
const INSTAVOLT_GREY = "/assets/networkFilter/InstaVolt_grey.svg";
const INSTAVOLT_RED = "/assets/networkFilter/InstaVolt_red.svg";
const IOCL = "/assets/networkFilter/IOCL.svg";
const IOCL_GREEN = "/assets/networkFilter/IOCL_green.svg";
const IOCL_GREY = "/assets/networkFilter/IOCL_grey.svg";
const IOCL_RED = "/assets/networkFilter/IOCL_red.svg";
const Kazam = "/assets/networkFilter/Kazam.svg";
const Kazam_GREEN = "/assets/networkFilter/Kazam_green.svg";
const Kazam_GREY = "/assets/networkFilter/Kazam_grey.svg";
const Kazam_RED = "/assets/networkFilter/Kazam_red.svg";
const KHT = "/assets/networkFilter/KHT.svg";
const KHT_GREEN = "/assets/networkFilter/KHT_green.svg";
const KHT_GREY = "/assets/networkFilter/KHT_grey.svg";
const KHT_RED = "/assets/networkFilter/KHT_red.svg";
const KROPEX = "/assets/networkFilter/Kropex.svg";
const KROPEX_GREEN = "/assets/networkFilter/Kropex_green.svg";
const KROPEX_GREY = "/assets/networkFilter/Kropex_grey.svg";
const KROPEX_RED = "/assets/networkFilter/Kropex_red.svg";
const MINOOKI = "/assets/networkFilter/Minooki.svg";
const MINOOKI_GREEN = "/assets/networkFilter/Minooki_green.svg";
const MINOOKI_GREY = "/assets/networkFilter/Minooki_grey.svg";
const MINOOKI_RED = "/assets/networkFilter/Minooki_red.svg";
const NTPC = "/assets/networkFilter/NTPC.svg";
const NTPC_GREEN = "/assets/networkFilter/NTPC_green.svg";
const NTPC_GREY = "/assets/networkFilter/NTPC_grey.svg";
const NTPC_RED = "/assets/networkFilter/NTPC_red.svg";
const OEM = "/assets/networkFilter/OEM.svg";
const OEM_GREEN = "/assets/networkFilter/OEM_green.svg";
const OEM_GREY = "/assets/networkFilter/OEM_grey.svg";
const OEM_RED = "/assets/networkFilter/OEM_red.svg";
const OLA = "/assets/networkFilter/Ola.svg";
const OLA_GREEN = "/assets/networkFilter/Ola_green.svg";
const OLA_GREY = "/assets/networkFilter/Ola_grey.svg";
const OLA_RED = "/assets/networkFilter/Ola_red.svg";
const PGCIL = "/assets/networkFilter/PGCIL.svg";
const PGCIL_GREEN = "/assets/networkFilter/PGCIL_green.svg";
const PGCIL_GREY = "/assets/networkFilter/PGCIL_grey.svg";
const PGCIL_RED = "/assets/networkFilter/PGCIL_red.svg";
const PLUGZMART = "/assets/networkFilter/PlugzMart.svg";
const PLUGZMART_GREEN = "/assets/networkFilter/PlugzMart_green.svg";
const PLUGZMART_GREY = "/assets/networkFilter/PlugzMart_grey.svg";
const PLUGZMART_RED = "/assets/networkFilter/PlugzMart_red.svg";
const REIL = "/assets/networkFilter/REIL.svg";
const REIL_GREEN = "/assets/networkFilter/REIL_green.svg";
const REIL_GREY = "/assets/networkFilter/REIL_grey.svg";
const REIL_RED = "/assets/networkFilter/REIL_red.svg";
const TCIL = "/assets/networkFilter/TCIL.svg";
const TCIL_GREEN = "/assets/networkFilter/TCIL_green.svg";
const TCIL_GREY = "/assets/networkFilter/TCIL_grey.svg";
const TCIL_RED = "/assets/networkFilter/TCIL_red.svg";
const VerdeMobility = "/assets/networkFilter/verde.svg";
const VerdeMobility_GREEN = "/assets/networkFilter/verde_green.svg";
const VerdeMobility_GREY = "/assets/networkFilter/verde_grey.svg";
const VerdeMobility_RED = "/assets/networkFilter/verde_red.svg";

const { socketType, chargePointSpeed, vehicleSegment,networkFilter, imageMapper, googleMap, types } = Constant;

// Removed homeServicelList as WidgetsIcon is not used and import was removed.

const images = {
    [socketType.CCS_TYPE_2]: PlugCCSType2,
    [socketType.TYPE_1]: PlugType1,
    [socketType.TYPE_2]: PlugType2,
    [socketType.TYPE_1_AC]: PlugType1AC,
    [socketType.CHADEMO]: PlugChademo,
    [socketType.GBT]: PlugGbt,
    [socketType.PIN_3]: PlugType3Pin,
    [socketType.BHARAT_AC_001]: PlugType3Pin,
    [socketType.BHARAT_DC_001]: PlugGbt,
    [socketType.CCS_SAE]: PlugTypeCSSSAE,
    [socketType.CCS_TYPE_1]: PlugTypeCCSType1,
    [socketType.J1772]: PlugTypeJ1772,
    [socketType.THREE_Phase]: PlugTypeThreePhase,
    [socketType.WAll]: PlugTypeWall,
    [socketType.IEC60309]: PlugTypeIEC60309,
    [chargePointSpeed.SPEED_SLOW]: SlowPNG,
    [chargePointSpeed.SPEED_FAST]: SpeedFastPNG,
    [chargePointSpeed.SPEED_RAPID]: SpeedRapidPNG,
    [chargePointSpeed.SPEED_ULTRA_RAPID]: SpeedUltraRapidPNG,
    [vehicleSegment.SEGMENT_2_WHEELER]: EV16PNG,
    [vehicleSegment.SEGMENT_3_WHEELER]: EV18PNG,
    [vehicleSegment.SEGMENT_4_WHEELER]: EV15PNG,
    [vehicleSegment.SEGMENT_SWIPE]: EV19PNG,
    [vehicleSegment.SEGMENT_2_WHEELER_GENERIC]: twoWheelerGeneric,
    [vehicleSegment.SEGMENT_3_WHEELER_GENERIC]: threeWheelerGeneric,
    [vehicleSegment.SEGMENT_4_WHEELER_GENERIC]: fourWheelerGeneric,
    [imageMapper.FAULT_CONNECTOR_IMAGE]: FaultConnectorImage,
    [imageMapper.ICON_14]: Icon14,
    [imageMapper.ICON_15]: Icon15,
    [imageMapper.ICON_16]: Icon16,
    [imageMapper.ICON_17]: Icon17,
    [networkFilter.AARGO]: AARGO,
    [`${networkFilter.AARGO}_GREEN`]: AARGO_GREEN,
    [`${networkFilter.AARGO}_RED`]: AARGO_RED,
    [`${networkFilter.AARGO}_GREY`]: AARGO_GREY,
    [networkFilter.ATHER]: ATHER,
    [`${networkFilter.ATHER}_GREEN`]: ATHER_GREEN,
    [`${networkFilter.ATHER}_RED`]: ATHER_RED,
    [`${networkFilter.ATHER}_GREY`]: ATHER_GREY,
    [networkFilter.CHARGE_GRID]: CHARGE_GRID,
    [`${networkFilter.CHARGE_GRID}_GREEN`]: CHARGE_GRID_GREEN,
    [`${networkFilter.CHARGE_GRID}_RED`]: CHARGE_GRID_RED,
    [`${networkFilter.CHARGE_GRID}_GREY`]: CHARGE_GRID_GREY,
    [networkFilter.CHARGE_ZONE]: CHARGE_ZONE,
    [`${networkFilter.CHARGE_ZONE}_GREEN`]: CHARGE_ZONE_GREEN,
    [`${networkFilter.CHARGE_ZONE}_RED`]: CHARGE_ZONE_RED,
    [`${networkFilter.CHARGE_ZONE}_GREY`]: CHARGE_ZONE_GREY,
    [networkFilter.EFILL]: EFILL,
    [`${networkFilter.EFILL}_GREEN`]: EFILL_GREEN,
    [`${networkFilter.EFILL}_RED`]: EFILL_RED,
    [`${networkFilter.EFILL}_GREY`]: EFILL_GREY,
    [networkFilter.ELECTRIVA]: ELECTRIVA,
    [`${networkFilter.ELECTRIVA}_GREEN`]: ELECTRIVA_GREEN,
    [`${networkFilter.ELECTRIVA}_RED`]: ELECTRIVA_RED,
    [`${networkFilter.ELECTRIVA}_GREY`]: ELECTRIVA_GREY,
    [networkFilter.EVRE]: EVRE,
    [`${networkFilter.EVRE}_GREEN`]: EVRE_GREEN,
    [`${networkFilter.EVRE}_RED`]: EVRE_RED,
    [`${networkFilter.EVRE}_GREY`]: EVRE_GREY,
    [networkFilter.FORTUM]: FORTUM,
    [`${networkFilter.FORTUM}_GREEN`]: FORTUM_GREEN,
    [`${networkFilter.FORTUM}_RED`]: FORTUM_RED,
    [`${networkFilter.FORTUM}_GREY`]: FORTUM_GREY,
    [networkFilter.GOEGO]: GOEGO,
    [`${networkFilter.GOEGO}_GREEN`]: GOEGO_GREEN,
    [`${networkFilter.GOEGO}_RED`]: GOEGO_RED,
    [`${networkFilter.GOEGO}_GREY`]: GOEGO_GREY,
    [networkFilter.RELUX]: RELUX,
    [`${networkFilter.RELUX}_GREEN`]: RELUX_GREEN,
    [`${networkFilter.RELUX}_RED`]: RELUX_RED,
    [`${networkFilter.RELUX}_GREY`]: RELUX_GREY,
    [networkFilter.STATIQ]: STATIQ,
    [`${networkFilter.STATIQ}_GREEN`]: STATIQ_GREEN,
    [`${networkFilter.STATIQ}_RED`]: STATIQ_RED,
    [`${networkFilter.STATIQ}_GREY`]: STATIQ_GREY,
    [networkFilter.TATA]: TATA,
    [`${networkFilter.TATA}_GREEN`]: TATA_GREEN,
    [`${networkFilter.TATA}_RED`]: TATA_RED,
    [`${networkFilter.TATA}_GREY`]: TATA_GREY,
    [networkFilter.VOLTTIC]: VOLTTIC,
    [`${networkFilter.VOLTTIC}_GREEN`]: VOLTTIC_GREEN,
    [`${networkFilter.VOLTTIC}_RED`]: VOLTTIC_RED,
    [`${networkFilter.VOLTTIC}_GREY`]: VOLTTIC_GREY,
    [networkFilter.JIO_BP]: JIO_BP,
    [`${networkFilter.JIO_BP}_GREEN`]: JIO_BP_GREEN,
    [`${networkFilter.JIO_BP}_RED`]: JIO_BP_RED,
    [`${networkFilter.JIO_BP}_GREY`]: JIO_BP_GREY,
    [networkFilter.XOBOLT]: XOBOLT,
    [`${networkFilter.XOBOLT}_GREEN`]: XOBOLT_GREEN,
    [`${networkFilter.XOBOLT}_RED`]: XOBOLT_RED,
    [`${networkFilter.XOBOLT}_GREY`]: XOBOLT_GREY,
    [networkFilter.ZEON]: ZEON,
    [`${networkFilter.ZEON}_GREEN`]: ZEON_GREEN,
    [`${networkFilter.ZEON}_RED`]: ZEON_RED,
    [`${networkFilter.ZEON}_GREY`]: ZEON_GREY,
    [networkFilter.BECIL]: BECIL,
    [`${networkFilter.BECIL}_GREEN`]: BECIL_GREEN,
    [`${networkFilter.BECIL}_RED`]: BECIL_RED,
    [`${networkFilter.BECIL}_GREY`]: BECIL_GREY,
    [networkFilter.IOCL]: IOCL,
    [`${networkFilter.IOCL}_GREEN`]: IOCL_GREEN,
    [`${networkFilter.IOCL}_RED`]: IOCL_RED,
    [`${networkFilter.IOCL}_GREY`]: IOCL_GREY,
    [networkFilter.KHT]: KHT,
    [`${networkFilter.KHT}_GREEN`]: KHT_GREEN,
    [`${networkFilter.KHT}_RED`]: KHT_RED,
    [`${networkFilter.KHT}_GREY`]: KHT_GREY,
    [networkFilter.Kazam]: Kazam,
    [`${networkFilter.Kazam}_GREEN`]: Kazam_GREEN,
    [`${networkFilter.Kazam}_RED`]: Kazam_RED,
    [`${networkFilter.Kazam}_GREY`]: Kazam_GREY,
    [networkFilter.EESL]: EESL,
    [`${networkFilter.EESL}_GREEN`]: EESL_GREEN,
    [`${networkFilter.EESL}_RED`]: EESL_RED,
    [`${networkFilter.EESL}_GREY`]: EESL_GREY,
    [networkFilter.GENERIC]: GENERIC,
    [`${networkFilter.GENERIC}_GREEN`]: GENERIC_GREEN,
    [`${networkFilter.GENERIC}_RED`]: GENERIC_RED,
    [`${networkFilter.GENERIC}_GREY`]: GENERIC_GREY,
    [networkFilter.VERDE_MOBILITY]: VerdeMobility,
    [`${networkFilter.VERDE_MOBILITY}_GREEN`]: VerdeMobility_GREEN,
    [`${networkFilter.VERDE_MOBILITY}_RED`]: VerdeMobility_RED,
    [`${networkFilter.VERDE_MOBILITY}_GREY`]: VerdeMobility_GREY,
    [networkFilter.MINOOKI]: MINOOKI,
    [`${networkFilter.MINOOKI}_GREEN`]: MINOOKI_GREEN,
    [`${networkFilter.MINOOKI}_RED`]: MINOOKI_RED,
    [`${networkFilter.MINOOKI}_GREY`]: MINOOKI_GREY,
    [networkFilter.PLUGZMART]: PLUGZMART,
    [`${networkFilter.PLUGZMART}_GREEN`]: PLUGZMART_GREEN,
    [`${networkFilter.PLUGZMART}_RED`]: PLUGZMART_RED,
    [`${networkFilter.PLUGZMART}_GREY`]: PLUGZMART_GREY,
    [networkFilter.BBMP]: BBMP,
    [`${networkFilter.BBMP}_GREEN`]: BBMP_GREEN,
    [`${networkFilter.BBMP}_RED`]: BBMP_RED,
    [`${networkFilter.BBMP}_GREY`]: BBMP_GREY,
    [networkFilter.OEM]: OEM,
    [`${networkFilter.OEM}_GREEN`]: OEM_GREEN,
    [`${networkFilter.OEM}_RED`]: OEM_RED,
    [`${networkFilter.OEM}_GREY`]: OEM_GREY,
    [networkFilter.PGCIL]: PGCIL,
    [`${networkFilter.PGCIL}_GREEN`]: PGCIL_GREEN,
    [`${networkFilter.PGCIL}_RED`]: PGCIL_RED,
    [`${networkFilter.PGCIL}_GREY`]: PGCIL_GREY,
    [networkFilter.DELTA]: DELTA,
    [`${networkFilter.DELTA}_GREEN`]: DELTA_GREEN,
    [`${networkFilter.DELTA}_RED`]: DELTA_RED,
    [`${networkFilter.DELTA}_GREY`]: DELTA_GREY,
    [networkFilter.NTPC]: NTPC,
    [`${networkFilter.NTPC}_GREEN`]: NTPC_GREEN,
    [`${networkFilter.NTPC}_RED`]: NTPC_RED,
    [`${networkFilter.NTPC}_GREY`]: NTPC_GREY,
    [networkFilter.INSTAVOLT]: INSTAVOLT,
    [`${networkFilter.INSTAVOLT}_GREEN`]: INSTAVOLT_GREEN,
    [`${networkFilter.INSTAVOLT}_RED`]: INSTAVOLT_RED,
    [`${networkFilter.INSTAVOLT}_GREY`]: INSTAVOLT_GREY,
    [networkFilter.OLA]: OLA,
    [`${networkFilter.OLA}_GREEN`]: OLA_GREEN,
    [`${networkFilter.OLA}_RED`]: OLA_RED,
    [`${networkFilter.OLA}_GREY`]: OLA_GREY,
    [networkFilter.REIL]: REIL,
    [`${networkFilter.REIL}_GREEN`]: REIL_GREEN,
    [`${networkFilter.REIL}_RED`]: REIL_RED,
    [`${networkFilter.REIL}_GREY`]: REIL_GREY,
    [networkFilter.TCIL]: TCIL,
    [`${networkFilter.TCIL}_GREEN`]: TCIL_GREEN,
    [`${networkFilter.TCIL}_RED`]: TCIL_RED,
    [`${networkFilter.TCIL}_GREY`]: TCIL_GREY,
    [networkFilter.KROPEX]: KROPEX,
    [`${networkFilter.KROPEX}_GREEN`]: KROPEX_GREEN,
    [`${networkFilter.KROPEX}_RED`]: KROPEX_RED,
    [`${networkFilter.KROPEX}_GREY`]: KROPEX_GREY,
};

const getImage = (key) => {
    return images[key];
}

// Use SVGs as image URLs, not React components
export const socketTypeList = [
    { type: socketType.CCS_TYPE_2, value: "connector1", src: PlugCCSType2, id: 1 },
    { type: socketType.TYPE_2, value: "connector2", src: PlugType2, id: 2 },
    { type: socketType.CHADEMO, value: "connector3", src: PlugChademo, id: 3 },
    { type: socketType.TYPE_1, value: "connector4", src: PlugType1, id: 4 },
    { type: socketType.TYPE_1_AC, value: "connector5", src: PlugType1AC, id: 5 },
    { type: socketType["3_PIN"], value: "connector6", src: PlugType3Pin, id: 6 },
    { type: socketType.GBT, value: "connector7", src: PlugGbt, id: 7 },
    { type: socketType.CCS_TYPE_1, value: "ccstype1", src: PlugTypeCCSType1, id: 8 },
    { type: socketType.CCS_SAE, value: "ccssae", src: PlugTypeCSSSAE, id: 9 },
    { type: socketType.THREE_Phase, value: "threephase", src: PlugTypeThreePhase, id: 10 },
    { type: socketType.WAll, value: "wall", src: PlugTypeWall, id: 11 },
    { type: socketType.J1772, value: "j1772", src: PlugTypeJ1772, id: 12 },
    { type: socketType.IEC60309, value: "ie60309", src: PlugTypeIEC60309, id: 13 }
];

export const chargePointSpeedList = [
    { type: chargePointSpeed.SPEED_SLOW, value: 'power1', src: getImage(chargePointSpeed.SPEED_SLOW), id: 1, kw: '< 7kw', alt: 'Slow charger icon', text: 'Slow' },
    { type: chargePointSpeed.SPEED_FAST, value: 'power2', src: getImage(chargePointSpeed.SPEED_FAST), id: 2, kw: '7-22kw', alt: 'Fast charger icon', text: 'Fast', },
    { type: chargePointSpeed.SPEED_RAPID, value: 'power3', src: getImage(chargePointSpeed.SPEED_RAPID), id: 3, kw: '22-50kw', alt: 'Rapid carger icon', text: 'Rapid' },
    { type: chargePointSpeed.SPEED_ULTRA_RAPID, value: 'power4', src: getImage(chargePointSpeed.SPEED_ULTRA_RAPID), id: 4, kw: '> 50kw', alt: 'Ultra Rapid charger icon', text: 'Ultra Rapid', }
]

export const networkFilterList = Object.entries(networkFilter).map(([key,value])=>({name:value,src:getImage(key),activeSrc:getImage(`${key}_GREEN`)?getImage(`${key}_GREEN`):null,inActiveSrc:getImage(`${key}_RED`)?getImage(`${key}_RED`):null,unknownSrc:getImage(`${key}_GREY`)?getImage(`${key}_GREY`):null}))


export const genericVehicleSegmentList = [
    { id: 2, src: getImage(vehicleSegment.SEGMENT_2_WHEELER_GENERIC), name: vehicleSegment.SEGMENT_2_WHEELER_GENERIC, value: vehicleSegment.SEGMENT_2_WHEELER_GENERIC  },
    { id: 3, src: getImage(vehicleSegment.SEGMENT_3_WHEELER_GENERIC), name: vehicleSegment.SEGMENT_3_WHEELER_GENERIC, value: vehicleSegment.SEGMENT_3_WHEELER_GENERIC },
    { id: 4, src: getImage(vehicleSegment.SEGMENT_4_WHEELER_GENERIC),  name: vehicleSegment.SEGMENT_4_WHEELER_GENERIC, value: vehicleSegment.SEGMENT_4_WHEELER_GENERIC },
]

export const reportIssuesList = [
    { id: 1, value: 'LOCATION', text: 'Issue with charger location' },
    { id: 2, value: 'DETAIL', text: 'Charger details are incorrect' },
    { id: 3, value: 'CARD', text: 'Payment not working' },
    { id: 4, value: 'CABLE', text: 'My cable is stuck' }
]

export const getConnectors = (devices) => {
    let connectorWithCount = [];
    //let connector, power, vSegment;
    let cType = {}

    if (devices?.length > 0) {
        for (let i = 0; i < devices?.length; i++) {
            if (devices[i]?.stations?.length > 0) {
                for (let j = 0; j < devices[i]?.stations?.length; j++) {
                    if (devices[i]?.stations[j]?.connector) {
                        let connectorType = devices[i]?.stations[j]?.connector;
                        if (cType[connectorType]) {
                            cType[connectorType] = cType[connectorType] + 1;
                        } else {
                            cType[connectorType] = 1;
                        }
                        }
                    }
                }
            }
        }

    let connectors = Object.keys(cType);
    if (connectors?.length > 0) {
        for (let i = 0; i < connectors.length; i++) {
            let connector = socketTypeList.find(socket => socket.value === connectors[i] || Number(socket.id)===Number(connectors[i]));
            connectorWithCount.push({
                connectorId: connectors[i],
                connectorTypeImage: connector ? connector.src : PlugCCSType2PNG,
                count: cType[connectors[i]]
            })
        }
    } else {
        connectorWithCount.push({
        connectorTypeImage: PlugCCSType2PNG,
            count: 1
    })
    }
    return connectorWithCount;
}

export const getMarkerIcon = (status, network) => {
    let markerIcon = DefaultMarkerPNG;
    if (network) {
        markerIcon = getImage(network);
        if (status === 'a' || status === 'available') {
            markerIcon = getImage(`${network}_GREEN`) || getImage(network);
        } else if (status === 'o' || status === 'occupied') {
            markerIcon = getImage(`${network}_RED`) || getImage(network);
        } else if (status === 'u' || status === 'unavailable') {
            markerIcon = getImage(`${network}_GREY`) || getImage(network);
        }
    }
    return markerIcon;
}

export default getImage;